import api from '../api/axios';

const FinancialAccountService = {
  getAll: async () => {
    const response = await api.get('/FinancialAccount/get-all');
    return response.data;
  },

  getDetail: async (id) => {
    const response = await api.get(`/FinancialAccount/get-detail/${id}`);
    return response.data;
  },

  create: async (account) => {
    const response = await api.post('/FinancialAccount/create', { account });
    return response.data;
  },

  update: async (account) => {
    const response = await api.post('/FinancialAccount/update', { account });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/FinancialAccount/delete/${id}`);
    return response.data;
  },

  addTransaction: async (transaction) => {
    const response = await api.post('/FinancialAccount/add-transaction', transaction);
    return response.data;
  },

  transfer: async (transferData) => {
    const response = await api.post('/FinancialAccount/transfer', transferData);
    return response.data;
  },

  getInstallments: async () => {
    const response = await api.get('/FinancialAccount/installments');
    return response.data;
  },

  payInstallment: async (payload) => {
    const response = await api.post('/FinancialAccount/pay-installment', payload);
    return response.data;
  }
};

export default FinancialAccountService;
